import { render, staticRenderFns } from "./PromotionDiscountValue.vue?vue&type=template&id=455933b8&"
import script from "./PromotionDiscountValue.vue?vue&type=script&lang=js&"
export * from "./PromotionDiscountValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports